import { ChangeDetectionStrategy, Component } from '@angular/core';
import { environment } from 'src/libs/angular/core/src/lib/environments/environment';

@Component({
  selector: 'aa-app-bar',
  standalone: true,
  imports: [],
  templateUrl: './app-bar.component.html',
  styleUrl: './app-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppBarComponent {
  customerAppURLBase = environment.customerAppURL;
}
